export const getRegion = (i) => {
  if (i.region) return i.region;
  switch (i.key) {
    case 'territory_region':
      return i.region;
    case 'territoryActivation':
      return 'Activation';
    case 'groupName':
      return 'Managed';
    case 'qualityService':
      return 'Quality Service';
    case 'distributor':
      return 'Wholesaler';
    case 'distributorSecondary':
      return 'Wholesaler';
    default:
      return i.region;
  }
}
